var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-64594b12\",\"hasScoped\":false}!../../vue-loader/lib/selector?type=template&index=0!./bio2-4.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-loader!./~/vue-markdown-loader/_cache/bio2-4.vue
// module id = 166
// module chunks = 0